// extracted by mini-css-extract-plugin
export var container = "QuantityButton-module--container--3Qlyq";
export var btn = "QuantityButton-module--btn--2HkB2";
export var icon = "QuantityButton-module--icon--YTonz";
export var label = "QuantityButton-module--label--3mL2J";